export const CONFIG_INFOS = 'CONFIG_INFOS';
